import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { L10n, setCulture } from "@syncfusion/ej2-base";
import { jaLocalization } from "../../assets/language/ja";
import { koLocalization } from "../../assets/language/ko";
import { frLocalization } from "../../assets/language/fr";
import { zhLocalization } from "../../assets/language/zh-CN";
import { twLocalization } from "../../assets/language/zh-TW";
@Injectable()
export class TranslationService {
  constructor(private http: HttpClient) {}
  getTranslation(selectLang?: string) {
    const localLang = localStorage.getItem("language");
    if (!selectLang) {
      selectLang = localLang || "en";
    }
    return new Promise((resolve) => {
      let code = this.convertLangValue(selectLang);
      if (selectLang != localLang) {
        localStorage.setItem("language", selectLang);
      }
      const data = { lang: code };
      this.http
        .post(`/api/ws/UserServiceWS.asmx/GetTranslation`, data)
        .subscribe({
          next: (res: any) => {
            localStorage.setItem("translation", JSON.stringify(res));
            this.updateSyncfusionLanguage();
            resolve("success");
          },
        });
    });
  }
  convertLangValue(code) {
    let value =
      code == "en"
        ? 1
        : code == "zh-tw"
        ? 2
        : code == "zh-cn"
        ? 3
        : code == "ja-jp"
        ? 4
        : code == "ko-kr"
        ? 5
        : code == "fr-fr"
        ? 6
        : 1;
    return value;
  }

  convertLangCode(value) {
    let code =
      value == 1
        ? "en"
        : value == 2
        ? "zh-tw"
        : value == 3
        ? "zh-cn"
        : value == 4
        ? "ja-jp"
        : value == 5
        ? "ko-kr"
        : value == 6
        ? "fr-fr"
        : "en";
    return code;
  }

  updateSyncfusionLanguage() {
    const localLang = localStorage.getItem("language");
    if (localLang === "zh-cn") {
      setCulture("zh");
      L10n.load(zhLocalization);
    } else if (localLang === "zh-tw") {
      setCulture("zh-Hant-HK");
      L10n.load(twLocalization);
    } else if (localLang === "ja-jp") {
      setCulture("ja");
      L10n.load(jaLocalization);
    } else if (localLang === "ko-kr") {
      setCulture("ko");
      L10n.load(koLocalization);
    } else if (localLang === "fr-fr") {
      setCulture("fr");
      L10n.load(frLocalization);
    }
  }
}
